import { Form, type FormItemProps } from 'antd';

import styled from '@emotion/styled';

export const FormItem = styled(Form.Item)<FormItemProps>`
  && {
    margin-bottom: 16px;
  }
`;
